/*
 * beni-media-drag.js — PC 端（≥750px）产品主图拖拽滑动
 * 让缩略图布局下的桌面主图支持鼠标按住左右拖拽切换（类似移动端触摸滑动）。
 * 只负责拖拽横滚；页码与缩略图高亮仍由 Dawn 的 SliderComponent + media-gallery.js 原生链路更新。
 */
(function () {
  var mql = window.matchMedia('(min-width: 750px)');
  var DRAG_THRESHOLD = 5;

  function initDrag(list) {
    if (list.dataset.beniDragBound) return;
    list.dataset.beniDragBound = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;

    // 禁止图片原生拖影，避免与拖拽冲突
    list.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
    });

    list.addEventListener('mousedown', function (e) {
      if (!mql.matches || e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = list.scrollLeft;
    });

    // 用 window 监听 move/up，拖出画廊区域仍能跟随
    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
        moved = true;
        list.classList.add('beni-dragging');
      }
      if (moved) {
        e.preventDefault();
        list.scrollLeft = startScroll - dx;
      }
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      if (list.classList.contains('beni-dragging')) {
        list.classList.remove('beni-dragging');
        snapToNearest(list);
      }
    });

    // 拖拽后拦截误触发的点击（图片放大 / 链接）
    list.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  // 松手后平滑吸附到最近一张（滚动结束会触发 SliderComponent.update 更新页码/缩略图）
  function snapToNearest(list) {
    var item = list.querySelector('.product__media-item');
    if (!item) return;
    var w = item.getBoundingClientRect().width;
    if (!w) return;
    var page = Math.round(list.scrollLeft / w);
    list.scrollTo({ left: page * w, behavior: 'smooth' });
  }

  function init() {
    document.querySelectorAll('media-gallery [id^="Slider-Gallery"]').forEach(initDrag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
